export const GET_SLIDER_ARTICLES = "GET_SLIDER_ARTICLES";
export const GET_SLIDER_ARTICLES_SUCCESS = "GET_SLIDER_ARTICLES_SUCCESS";
export const GET_SLIDER_ARTICLES_FAIL = "GET_SLIDER_ARTICLES_FAIL";
